import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "how-to-play" }
const _hoisted_2 = { class: "sections" }
const _hoisted_3 = { class: "instruction-section" }
const _hoisted_4 = { class: "section-content image-first" }
const _hoisted_5 = { class: "image-content" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "instruction-section" }
const _hoisted_8 = { class: "section-content image-last" }
const _hoisted_9 = { class: "image-content" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "instruction-section" }
const _hoisted_12 = { class: "section-content image-first" }
const _hoisted_13 = { class: "image-content" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "instruction-section" }
const _hoisted_16 = { class: "section-content image-last" }
const _hoisted_17 = { class: "image-content" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "instruction-section" }
const _hoisted_20 = { class: "section-content image-first" }
const _hoisted_21 = { class: "image-content" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "instruction-section" }
const _hoisted_24 = { class: "section-content image-last" }
const _hoisted_25 = { class: "image-content" }
const _hoisted_26 = ["src"]

import { computed } from 'vue'

import { useTheme } from '@/composables/useTheme'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'HowToPlayView'
},
  __name: 'HowToPlayView',
  setup(__props) {



const { getAssetPath } = useTheme()

const howToPlayStep1 = computed(() => getAssetPath('howToPlay', 'step1') || '/img/images/how-to-play/1-select-game.png')
const howToPlayStep2 = computed(() => getAssetPath('howToPlay', 'step2') || '/img/images/how-to-play/2-select-draws.png')
const howToPlayStep3 = computed(() => getAssetPath('howToPlay', 'step3') || '/img/images/how-to-play/3-select-market.png')
const howToPlayStep4 = computed(() => getAssetPath('howToPlay', 'step4') || '/img/images/how-to-play/4-confirm-your-entries.png')
const howToPlayStep5 = computed(() => getAssetPath('howToPlay', 'step5') || '/img/images/how-to-play/5-your-betslip.png')
const howToPlayStep6 = computed(() => getAssetPath('howToPlay', 'step6') || '/img/images/how-to-play/6-wager-details.png')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "section-title large" }, "How to Play", -1)),
    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "subtitle" }, "With coverage of 160+ Lucky Numbers games, we will show you how to quickly start playing so that you don't miss out.", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: howToPlayStep1.value,
              alt: "Select Your Game"
            }, null, 8, _hoisted_6)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-content" }, [
            _createElementVNode("h3", null, "SELECT YOUR GAME"),
            _createElementVNode("p", null, "Browse our extensive selection of Lucky Numbers games from around the world. Click the \"BET\" button on any game card to view available betting markets and start your wager."),
            _createElementVNode("p", null, "You can explore upcoming draws on the main page or use the search and filter options to find your preferred game."),
            _createElementVNode("p", null, "Each game features unique draw times and betting opportunities, giving you multiple chances to win throughout the day.")
          ], -1))
        ])
      ]),
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-content" }, [
            _createElementVNode("h3", null, "SELECT YOUR DRAWS"),
            _createElementVNode("p", null, "After choosing your game, you'll see a list of upcoming draws available for betting. Select one or more draws by checking the boxes next to each draw date and time."),
            _createElementVNode("p", null, "The available draws are limited to draws within a week period. For Rapid Lucky Numbers, a maximum of 10 draws will be available due to their frequent occurrence."),
            _createElementVNode("p", null, "You can select multiple draws to increase your winning potential while placing a single wager.")
          ], -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: howToPlayStep2.value,
              alt: "Select Your Draws"
            }, null, 8, _hoisted_10)
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              src: howToPlayStep3.value,
              alt: "Select Your Market"
            }, null, 8, _hoisted_14)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-content" }, [
            _createElementVNode("h3", null, "SELECT YOUR MARKET"),
            _createElementVNode("p", null, "Choose from a variety of betting markets based on the game type. Options include selecting specific numbers, betting on sum totals (odd/even, over/under), or predicting bonus ball outcomes."),
            _createElementVNode("p", null, "For standard bet markets, select your numbers from the available number pool. For sum-based markets, simply choose your prediction (odd/even or over/under the boundary)."),
            _createElementVNode("p", null, "Once you've made your selection, the wager will be added to your betslip automatically.")
          ], -1))
        ])
      ]),
      _createElementVNode("section", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-content" }, [
            _createElementVNode("h3", null, "CONFIRM YOUR ENTRIES"),
            _createElementVNode("p", null, "Review your selections in the confirmation section. You can add multiple lines to your wager or modify your selections before finalizing."),
            _createElementVNode("p", null, "Adjust your stake per entry if desired. The system will display the total possible winnings for each line based on the odds and your stake amount."),
            _createElementVNode("p", null, "Verify all your selections, stake amounts, and potential payouts before proceeding to the betslip.")
          ], -1)),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("img", {
              src: howToPlayStep4.value,
              alt: "Confirm Your Entries"
            }, null, 8, _hoisted_18)
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("img", {
              src: howToPlayStep5.value,
              alt: "Your Betslip"
            }, null, 8, _hoisted_22)
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-content" }, [
            _createElementVNode("h3", null, "YOUR BETSLIP"),
            _createElementVNode("p", null, "Your betslip displays all active wagers ready for placement. Review each entry including the selected draws, market type, numbers or predictions, stake, and potential winnings."),
            _createElementVNode("p", null, "You can modify individual stakes, remove any unwanted entries, or add more bets from other games before placing your final wager."),
            _createElementVNode("p", null, "Once you're satisfied with your selections, click the \"PLACE BET\" button to submit your wagers. All bets must be confirmed before the draw cutoff time.")
          ], -1))
        ])
      ]),
      _createElementVNode("section", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-content" }, [
            _createElementVNode("h3", null, "WAGER DETAILS"),
            _createElementVNode("p", null, "After placing your bet, navigate to the \"Wagers\" page to view all your betting history. Each transaction shows the date, description, status, total stake, and payout information."),
            _createElementVNode("p", null, "Access detailed information for each wager including transaction date, game details, draw information, market type, your selections, results, odds, and payout amount."),
            _createElementVNode("p", null, "Winnings are automatically credited to your account wallet once the draw results are published and your bet is successful.")
          ], -1)),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("img", {
              src: howToPlayStep6.value,
              alt: "Wager Details"
            }, null, 8, _hoisted_26)
          ])
        ])
      ])
    ])
  ]))
}
}

})